import { Modal, ModalContent } from "components/Modal"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { Button } from "components/Button"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { AddressBook } from "components/Icon/AddressBook"
import { useRouter } from "components/Router"

export const ObserverModal = ({
  isOpen,
  onRequestClose,
  messages: messagesProps,
  actions,
}) => {
  const translator = useTranslator()
  const connectedUser = useConnectedUser()
  const isExClub = connectedUser?.roles.includes("ROLE_EX_CLUB")
  const messages = getDefaultedMessages(messagesProps, isExClub, translator)
  const router = useRouter()

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={messages.title}
    >
      <ModalContent>
        <div className="flex flex-col space-y-4">
          <Text className="text-center" variant="body2">
            {messages.presentation}
          </Text>

          <Text className="text-center" variant="body2">
            {messages.description}
          </Text>

          <Button
            href={{
              route: isExClub
                ? "app_user_subscription_index"
                : "app_club_shop_plan_index",
            }}
            type="button"
            color="primary"
            iconLeft={<AddressBook className="w-4" />}
          >
            {messages.cta}
          </Button>

          <Button
            href={router.generate("app_club_home_redirect", {"id": 3})}
            color="secondary"
            variant="text"
          >
            {messages.whyButton}
          </Button>

          {actions}
        </div>
      </ModalContent>
    </Modal>
  )
}

const DEFAULT_MESSAGES = {
  title: "ObserverModal.notExClub.title",
  presentation: "ObserverModal.presentation",
  description: "ObserverModal.notExClub.description",
  cta: "ObserverModal.notExClub.cta",
  whyButton: "ObserverModal.whyButton",
}

const DEFAULT_MESSAGES_EX_CLUB = {
  title: "ObserverModal.exClub.title",
  presentation: "ObserverModal.presentation",
  description: "ObserverModal.exClub.description",
  cta: "ObserverModal.exClub.cta",
  whyButton: "ObserverModal.whyButton",
}

function getDefaultMessages(isExClub, translator) {
  const messages = isExClub ? DEFAULT_MESSAGES_EX_CLUB : DEFAULT_MESSAGES

  return Object.fromEntries(
    Object.entries(messages).map(([key, translationKey]) => [
      key,
      translator.trans(translationKey, null, "components"),
    ]),
  )
}

function getDefaultedMessages(providedMessages, isExClub, translator) {
  return { ...getDefaultMessages(isExClub, translator), ...providedMessages }
}
